import { Injectable, inject, signal } from '@angular/core';
import { Observable, tap } from 'rxjs';

import { PaymentService } from '@app/modules/payment/payment.service';

import { Payment, PaymentApiResponse } from '../payment/payment.entity';
import { Reward } from '../daily-rewards/daily-rewards.entity';

import { ProfileService } from './profile.service';
import {
  ApiResponse,
  ProfileStats,
  User,
  ProfileWebPushesStatus
} from './users.entity';

@Injectable()
export class ProfileState {
  private readonly profileService = inject(ProfileService);
  private readonly paymentService = inject(PaymentService);

  public readonly user = signal<User|null>(null);
  public readonly stats = signal<ProfileStats|null>(null);
  public readonly webPushes = signal<ProfileWebPushesStatus|null>(null);
  public readonly dailyRewardsCurrentPrize = signal<Reward|null>(null);
  public readonly deposits = signal<Payment[]|null>(null);
  public readonly canResetNeedPlayGames = signal<boolean>(false);

  loadProfile(id: number): Observable<ApiResponse.Profile> {
    return this.profileService.getProfile(id).pipe(
      tap((response: ApiResponse.Profile) => {
        this.user.set(response.user);
        this.stats.set(response.stats);
        this.webPushes.set(response.webPushes || null);
        this.dailyRewardsCurrentPrize.set(response.dailyRewardsCurrentPrize || null);
        this.canResetNeedPlayGames.set(response.canResetNeedPlayGames || false);
      })
    );
  }

  resetNeedPlayGames(): Observable<void> {
    return this.profileService.resetNeedPlayGames().pipe(
      tap(() => {
        this.canResetNeedPlayGames.set(false);
      })
    );
  }

  loadDeposits(): Observable<PaymentApiResponse.PaymentHistory> {
    return this.paymentService.getPaymentHistory().pipe(
      tap((response) => {
        this.deposits.set(response.payments);
      })
    );
  }
}